import React, { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import { Box, CardMedia } from "@mui/material";
import { useSelector } from "react-redux";
import { PF } from "../../config";
import { mergeManagedContent } from "../../hooks/mergeManagedContent";
import TrustPilotButton from "./TrustPilotButton";
import OndemandVideoOutlinedIcon from "@mui/icons-material/OndemandVideoOutlined";
import { colors, radii } from "../../theme/designTokens";

export default function ShortVideo() {
  // Store
  const { activeLangFront } = useSelector((state) => state.miscFront);
  const { managedContentSettings } = useSelector(
    (state) => state.managedContentSettings
  );
  const { langs } = useSelector((state) => state.misc);

  const [langId, setLangId] = useState("");
  const [video, setVideo] = useState("");
  const [contentSettings, setContentSettings] = useState([]);

  // Set Language
  useEffect(() => {
    if (activeLangFront) {
      setLangId(activeLangFront._id);
    }
  }, [activeLangFront]);

  // Set Settings
  useEffect(() => {
    if (
      managedContentSettings &&
      managedContentSettings.length > 0 &&
      langId !== ""
    ) {
      const M = mergeManagedContent(managedContentSettings, langId, langs);
      if (M) setContentSettings(M);
    }
  }, [langId, managedContentSettings]);

  useEffect(() => {
    if (
      contentSettings &&
      contentSettings.howToOrderVideos &&
      contentSettings.howToOrderVideos.length > 0
    ) {
      const V = contentSettings.howToOrderVideos.find((v) => v.default);
      if (V) {
        setVideo(V);
      }
      setVideo(contentSettings.howToOrderVideos[0]);
    }
  }, [contentSettings]);

  //! Translate
  // Store
  const { langArrFromClientSideFrontend } = useSelector(
    (state) => state.miscFront
  );
  const translateFront = (String) => {
    let translation = "";
    if (
      langArrFromClientSideFrontend &&
      langArrFromClientSideFrontend.length > 0
    ) {
      const T = langArrFromClientSideFrontend.find((l) => l.title === String);
      if (T && T.value) {
        let obj = { ...T };
        if (T.value === "") obj.value = T.title;
        translation = T.value;
      }
    }
    return translation;
  };
  //! Translate
  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, mb: 1.5 }}>
        <Box
          sx={{
            width: 32,
            height: 32,
            borderRadius: radii.md,
            bgcolor: colors.primaryLight,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <OndemandVideoOutlinedIcon sx={{ fontSize: 16, color: colors.primary }} />
        </Box>
        <Typography sx={{ fontWeight: 700, fontSize: 15, color: colors.ink }}>
          {translateFront("How To Order")}
        </Typography>
      </Box>
      <CardMedia
        component="video"
        image={PF + "misc/" + video.src}
        sx={{ borderRadius: radii.md, overflow: "hidden", bgcolor: colors.ink }}
        muted
        controls
        loop
      />
      <Box sx={{ mt: 1.5 }}>
        <TrustPilotButton />
      </Box>
    </>
  );
}
